<style lang="scss">
ul.tab-panes {
  padding: 0;
  margin: 0;
  display: flex;
  width: 100%;
}
</style>

<template>
  <ul class="tab-panes">
    <slot></slot>
  </ul>
</template>

<script>
import { TabEventBus } from './EventBus'

export default {
  name: 'TabPanes',
  props: {
    name: { type: String, required: true }
  },
  mounted() {
    this.$children[0].isShow = true

    TabEventBus.$on('tabchange', activeTab => {
      if (this.name !== activeTab.target) return

      this.$children.filter(child => child !== this.$children[activeTab.index]).forEach(child => (child.isShow = false))
      this.$children[activeTab.index].isShow = true
    })
  }
}
</script>
